import { render, staticRenderFns } from "./work-order-instruction-edit-form.html?vue&type=template&id=05f5e5ae&scoped=true&"
import script from "./work-order-instruction-edit-form.ts?vue&type=script&lang=js&"
export * from "./work-order-instruction-edit-form.ts?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "05f5e5ae",
  null
  
)

export default component.exports